import React from 'react';
import PropTypes from 'prop-types';

const Textarea = (props) => {
	const {rows, className, value, onChange, ...rest} = props;

	return (
		<textarea rows={rows} className={className} value={value} onChange={onChange} {...rest} />
	);
};

Textarea.defaultProps = {
	rows: 4,
	className: 'form-control'
};

Textarea.propTypes = {
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	rows: PropTypes.number,
	className: PropTypes.string
};

export default Textarea;